module.exports = "/assets/listing/chefsMenuBannerDesktop.png?ex7N9yn";